module.exports = __webpack_public_path__ + "img/articletop_xl.8cfc7af4.png";